// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video_section .video_filter,
.recentlywatched-videos .video_filter {
  background: linear-gradient(180deg, #d10451, #eb6d7e);
  position: relative;
  border-radius: 30px;
  padding: 4px;
}
.video_section .video_filter .nav-item,
.recentlywatched-videos .video_filter .nav-item {
  display: inline-block;
}
@media screen and (max-width: 767px) {
  .video_section .video_filter .nav-item,
  .recentlywatched-videos .video_filter .nav-item {
    width: 100%;
  }
}
.video_section .video_filter .nav-item:not(:last-child),
.recentlywatched-videos .video_filter .nav-item:not(:last-child) {
  margin-right: 6px;
}
.video_section .video_filter .nav-item .nav-link,
.recentlywatched-videos .video_filter .nav-item .nav-link {
  text-align: center;
  color: #ffffff;
  transition: all 0.2s linear;
  padding: 0.65rem 2rem;
  border-radius: 30px;
}
.video_section .video_filter .nav-item .nav-link.active, .video_section .video_filter .nav-item .nav-link:hover,
.recentlywatched-videos .video_filter .nav-item .nav-link.active,
.recentlywatched-videos .video_filter .nav-item .nav-link:hover {
  color: #fff;
  background: #ffc107;
}
.video_section .slider-wrapper .slick-slide > div,
.recentlywatched-videos .slider-wrapper .slick-slide > div {
  margin: 2px 8px;
}
.video_section .slider-wrapper .slick-list,
.recentlywatched-videos .slider-wrapper .slick-list {
  margin: 0 -15px;
}
.video_section .slider-wrapper .slick-list .slick-track,
.recentlywatched-videos .slider-wrapper .slick-list .slick-track {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.video_section .slider-wrapper .slick-slide,
.recentlywatched-videos .slider-wrapper .slick-slide {
  position: relative;
}
.video_section .slider-wrapper .slick-slide:focus,
.recentlywatched-videos .slider-wrapper .slick-slide:focus {
  outline: none;
}
.video_section .slider-wrapper .slick-prev,
.video_section .slider-wrapper .slick-next,
.recentlywatched-videos .slider-wrapper .slick-prev,
.recentlywatched-videos .slider-wrapper .slick-next {
  top: -12px;
  z-index: 1;
}
.video_section .slider-wrapper .slick-prev.slick-disabled .next-slick-arrow,
.video_section .slider-wrapper .slick-prev.slick-disabled .prev-slick-arrow,
.video_section .slider-wrapper .slick-next.slick-disabled .next-slick-arrow,
.video_section .slider-wrapper .slick-next.slick-disabled .prev-slick-arrow,
.recentlywatched-videos .slider-wrapper .slick-prev.slick-disabled .next-slick-arrow,
.recentlywatched-videos .slider-wrapper .slick-prev.slick-disabled .prev-slick-arrow,
.recentlywatched-videos .slider-wrapper .slick-next.slick-disabled .next-slick-arrow,
.recentlywatched-videos .slider-wrapper .slick-next.slick-disabled .prev-slick-arrow {
  color: #a5a5a5;
  box-shadow: 0 0.1rem 0.15rem rgba(0, 0, 0, 0.015);
}
.video_section .slider-wrapper .slick-prev,
.recentlywatched-videos .slider-wrapper .slick-prev {
  left: 270px;
}
.video_section .slider-wrapper .slick-next,
.recentlywatched-videos .slider-wrapper .slick-next {
  left: 295px;
}
.video_section .slider-wrapper .slick-next:before,
.video_section .slider-wrapper .slick-prev:before,
.recentlywatched-videos .slider-wrapper .slick-next:before,
.recentlywatched-videos .slider-wrapper .slick-prev:before {
  content: "" !important;
  color: #777777;
}
.video_section .slider-wrapper .next-slick-arrow,
.video_section .slider-wrapper .prev-slick-arrow,
.recentlywatched-videos .slider-wrapper .next-slick-arrow,
.recentlywatched-videos .slider-wrapper .prev-slick-arrow {
  color: #000000;
  font-size: 0.8rem;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.15);
  line-height: 25px;
}
.video_section .advance-videos .slider-wrapper .slick-prev,
.recentlywatched-videos .advance-videos .slider-wrapper .slick-prev {
  left: 290px;
}
.video_section .advance-videos .slider-wrapper .slick-next,
.recentlywatched-videos .advance-videos .slider-wrapper .slick-next {
  left: 315px;
}
.video_section .single-slide-card .card-header .slick-slide-image,
.recentlywatched-videos .single-slide-card .card-header .slick-slide-image {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
.video_section .single-slide-card .card-body,
.recentlywatched-videos .single-slide-card .card-body {
  min-height: 138px;
}
.video_section .single-slide-card .card-body .slick-slide-title,
.recentlywatched-videos .single-slide-card .card-body .slick-slide-title {
  font-size: 18px;
}
.video_section .single-slide-card .card-body .no-gutters > [class*=col-],
.recentlywatched-videos .single-slide-card .card-body .no-gutters > [class*=col-] {
  font-size: 13px;
  line-height: 18px;
}
.video_section .single-slide-card .card-footer button,
.recentlywatched-videos .single-slide-card .card-footer button {
  font-size: 12px;
  color: #ffffff;
  background: #202b63;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/videos/_videos.scss"],"names":[],"mappings":"AAEE;;EACE,qDAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AAEI;;EACE,qBAAA;AACN;AACM;EAHF;;IAII,WAAA;EAGN;AACF;AADM;;EACE,iBAAA;AAIR;AADM;;EACE,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;AAIR;AAFQ;;;EAEE,WAAA;EACA,mBAAA;AAKV;AAKI;;EACE,eAAA;AAFN;AAII;;EACE,eAAA;AADN;AAEM;;EACE,yBAAA;EACA,0BAAA;AACR;AAEI;;EACE,kBAAA;AACN;AACM;;EACE,aAAA;AAER;AAEI;;;;EAEE,UAAA;EACA,UAAA;AAEN;AAAQ;;;;;;;;EAEE,cAAA;EACA,iDAAA;AAQV;AAJI;;EACE,WAAA;AAON;AALI;;EACE,WAAA;AAQN;AALI;;;;EAEE,sBAAA;EACA,cAAA;AASN;AAPI;;;;EAEE,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,iBAAA;AAWN;AAPI;;EACE,WAAA;AAUN;AARI;;EACE,WAAA;AAWN;AANI;;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AASN;AANI;;EACE,iBAAA;AASN;AAPM;;EACE,eAAA;AAUR;AAPM;;EACE,eAAA;EACA,iBAAA;AAUR;AALM;;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;AAQR","sourcesContent":[".video_section,\n.recentlywatched-videos {\n  .video_filter {\n    background: linear-gradient(180deg, #d10451, #eb6d7e);\n    position: relative;\n    border-radius: 30px;\n    padding: 4px;\n\n    .nav-item {\n      display: inline-block;\n      // width: 32%;\n      @media screen and (max-width:767px) {\n        width: 100%;\n      }\n\n      &:not(:last-child) {\n        margin-right: 6px;\n      }\n\n      .nav-link {\n        text-align: center;\n        color: #ffffff;\n        transition: all 0.2s linear;\n        padding: 0.65rem 2rem;\n        border-radius: 30px;\n\n        &.active,\n        &:hover {\n          color: #fff;\n          background: #ffc107;\n        }\n      }\n    }\n  }\n\n  .slider-wrapper {\n    // width: 100%;\n    // margin: auto;\n\n    .slick-slide > div {\n      margin: 2px 8px;\n    }\n    .slick-list {\n      margin: 0 -15px;\n      .slick-track {\n        margin-left: 0 !important;\n        margin-right: 0 !important;\n      }\n    }\n    .slick-slide {\n      position: relative;\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    .slick-prev,\n    .slick-next {\n      top: -12px;\n      z-index: 1;\n      &.slick-disabled {\n        .next-slick-arrow,\n        .prev-slick-arrow {\n          color: #a5a5a5;\n          box-shadow: 0 0.1rem 0.15rem rgba(0, 0, 0, 0.015);\n        }\n      }\n    }\n    .slick-prev {\n      left: 270px;\n    }\n    .slick-next {\n      left: 295px;\n    }\n\n    .slick-next:before,\n    .slick-prev:before {\n      content: \"\" !important;\n      color: #777777;\n    }\n    .next-slick-arrow,\n    .prev-slick-arrow {\n      color: #000000;\n      font-size: 0.8rem;\n      width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: #ffffff;\n      border-radius: 50%;\n      box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.15);\n      line-height: 25px;\n    }\n  }\n  .advance-videos .slider-wrapper {\n    .slick-prev {\n      left: 290px;\n    }\n    .slick-next {\n      left: 315px;\n    }\n  }\n\n  .single-slide-card {\n    .card-header .slick-slide-image {\n      max-width: 100%;\n      height: auto;\n      border-radius: 4px;\n    }\n\n    .card-body {\n      min-height: 138px;\n\n      .slick-slide-title {\n        font-size: 18px;\n      }\n\n      .no-gutters > [class*=\"col-\"] {\n        font-size: 13px;\n        line-height: 18px;\n      }\n    }\n\n    .card-footer {\n      button {\n        font-size: 12px;\n        color: #ffffff;\n        background: #202b63;\n        text-decoration: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
